import React, {useEffect} from "react";
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { connect } from "react-redux";
import Typography from "@material-ui/core/Typography";
import { NotificationValue } from "../../actions/types";

const Alert = (props: AlertProps) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

export enum severityType {
  success = "success",
  info = "info",
  warning = "warning",
  error = "error"
}

type Props = {
  notification: NotificationValue;
}

const CustomizedSnackbar = (props: Props) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const { show, messageType, position, notification } = props.notification;

  useEffect(() => {
    setOpen(show);
  }, [show])

  return (
    <div className={ classes.root }>
      <Snackbar anchorOrigin={ position } open={ open }>
        <Alert severity={ messageType }>
          {
            notification.map((message, index) => (
              <Typography key={index} variant={"body2"}>{message}</Typography>
            ))
          }
        </Alert>
      </Snackbar>
    </div>
  );
}

const mapStateToProps = (state: Props) => {
  return {
    notification: state.notification
  };
};

export default connect(mapStateToProps)(CustomizedSnackbar);
